import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  // 仪表板设计器宽度
  dashboardDesignerWidth: 1200,
  // 预览标志
  previewFlag: false,
  // 当前面板图表
  curPanelChart: null,
  // 主上下文高度
  mainContextHeight: 600
}

const getters = {
  // 获取仪表板设计器宽度
  getDashboardDesignerWidth: state => state.dashboardDesignerWidth,
  
  // 获取预览标志
  getPreviewFlag: state => state.previewFlag,
  
  // 获取当前面板图表
  getCurPanelChart: state => state.curPanelChart,
  
  // 获取主上下文高度
  getMainContextHeight: state => state.mainContextHeight
}

const mutations = {
  // 设置仪表板设计器宽度
  setDashboardDesignerWidth(state, width) {
    state.dashboardDesignerWidth = width
  },
  
  // 设置预览标志
  setPreviewFlag(state, flag) {
    state.previewFlag = flag
  },
  
  // 设置当前面板图表
  setCurPanelChart(state, chart) {
    state.curPanelChart = chart
  },
  
  // 设置主上下文高度
  setMainContextHeight(state, height) {
    state.mainContextHeight = height
  }
}

const actions = {
  // 更新仪表板设计器宽度
  updateDashboardDesignerWidth({ commit }, width) {
    commit('setDashboardDesignerWidth', width)
  },
  
  // 切换预览模式
  togglePreviewFlag({ commit, state }) {
    commit('setPreviewFlag', !state.previewFlag)
  },
  
  // 设置当前面板图表
  updateCurPanelChart({ commit }, chart) {
    commit('setCurPanelChart', chart)
  },
  
  // 更新主上下文高度
  updateMainContextHeight({ commit }, height) {
    commit('setMainContextHeight', height)
  }
}

// 导出 store 配置对象
export const storeConfig = {
  state,
  getters,
  mutations,
  actions
}

// 也导出 store 实例（用于直接使用）
export default new Vuex.Store(storeConfig)
